const DetailsLayout = [
    {
        "groupId": 1,
        "label": "Location Tracking",
        "fields": [
            {
                "name": "USELOCATION",
                "tableName": "WMTRANSACTIONDP",
                "label": "Record #",
                "type": "select",
                "required": false,
                "visible": true,
                
            },
            {
                "name": "R_WAREHOUSE",
                "tableName": "WMTRANSACTIONDP",
                "label": "Profile",
                "type": "select",
                "required": false,
                "visible": true
            },
            {
                "name": "ALLOWBLANKLOCATIONS",
                "tableName": "WMTRANSACTIONDP",
                "label": "Description",
                "type": "select",
                "required": false,
                "visible": true
            },
            {
                "name": "LOCATIONBYCLASS",
                "tableName": "WMTRANSACTIONDP",
                "label": "Popup Msg",
                "type": "select",
                "required": false,
                "visible": true,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Receiving Code",
        "fields": [
            {
                "name": "RECEIVINGMETHOD_LOT",
                "tableName": "WMTRANSACTIONDP",
                "label": "Lot",
                "type": "select",
                "required": false,
                "visible": true,
                
            },
            {
                "name": "RECEIVINGMETHOD_SUBLOT",
                "tableName": "WMTRANSACTIONDP",
                "label": "Sublot",
                "type": "select",
                "required": true,
                "visible": true
            },
            {
                "name": "RECEIVINGMETHOD_UNIT",
                "tableName": "WMTRANSACTIONDP",
                "label": "Unit",
                "type": "select",
                "required": false,
                "visible": true
            },
            {
                "name": "LOCATIONMETHOD_RECEIPTS",
                "tableName": "WMTRANSACTIONDP",
                "label": "Location",
                "type": "select",
                "required": false,
                "visible": true,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "Access Master",
        "fields": [
            {
                "name": "SHOWMASTER_LOT",
                "tableName": "WMTRANSACTIONDP",
                "label": "Lot",
                "type": "select",
                "required": false,
                "visible": true,
                
            },
            {
                "name": "SHOWMASTER_SUBLOT",
                "tableName": "WMTRANSACTIONDP",
                "label": "Sublot",
                "type": "select",
                "required": true,
                "visible": true
            },
            {
                "name": "SHOWMASTER_UNIT",
                "tableName": "WMTRANSACTIONDP",
                "label": "Unit",
                "type": "select",
                "required": false,
                "visible": true
            },
            {
                "name": "Loc_Static",
                "tableName": "WMTRANSACTIONDP",
                "label": "Location",
                "type": "select",
                "required": false,
                "visible": true,
                "readOnly":true,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "Shipment Quantity Allocations",
        "fields": [
            {
                "name": "SHIPMENTSONNEG_AVL",
                "tableName": "WMTRANSACTIONDP",
                "label": "Allow (-) Avl",
                "type": "select",
                "required": false,
                "visible": true,
                
            },
            {
                "name": "IGNORESAMEDAYSHIPTIME",
                "tableName": "WMTRANSACTIONDP",
                "label": "Ignore Time",
                "type": "select",
                "required": true,
                "visible": true,
            },
            {
                "name": "SHIPMENTSONNET_AVL",
                "tableName": "WMTRANSACTIONDP",
                "label": "Orderd > Net Avl",
                "type": "select",
                "required": false,
                "visible": true
            },
            {
                "name": "SHIPMENTQTYCHKONDTLSAVE",
                "tableName": "WMTRANSACTIONDP",
                "label": "Orderd <> Act",
                "type": "select",
                "required": false,
                "visible": true,
            }
        ]
    },
    {
        "groupId": 5,
        "label": "Method",
        "fields": [
            {
                "name": "LOTMETHOD_SHIPMENTS",
                "tableName": "WMTRANSACTIONDP",
                "label": "Lot",
                "type": "select",
                "required": false,
                "visible": true,
                
            },
            {
                "name": "SUBLOTMETHOD_SHIPMENTS",
                "tableName": "WMTRANSACTIONDP",
                "label": "Sublot",
                "type": "select",
                "required": true,
                "visible": true
            },
            {
                "name": "UNITMETHOD_SHIPMENTS",
                "tableName": "WMTRANSACTIONDP",
                "label": "Unit",
                "type": "select",
                "required": false,
                "visible": true
            },
            {
                "name": "LOCATIONMETHOD_SHIPMENTS",
                "tableName": "WMTRANSACTIONDP",
                "label": "Location",
                "type": "select",
                "required": false,
                "visible": true
            }
        ]
    },
    {
        "groupId": 6,
        "label": "Pick Method",
        "fields": [
            {
                "name": "LOTPICKMETHOD_SHIPMENTS",
                "tableName": "WMTRANSACTIONDP",
                "label": "Lot",
                "type": "select",
                "required": false,
                "acceptCustomValue": true,
                "visible": true,
                
            },
            {
                "name": "SUBLOTPICKMETHOD_SHIPMENTS",
                "tableName": "WMTRANSACTIONDP",
                "label": "Sublot",
                "type": "select",
                "required": true,
                "acceptCustomValue": true,
                "visible": true
            },
            {
                "name": "UNITPICKMETHOD_SHIPMENTS",
                "tableName": "WMTRANSACTIONDP",
                "label": "Unit",
                "type": "select",
                "required": false,
                "acceptCustomValue": true,
                "visible": true
            },
            {
                "name": "LOCATIONPICKMETHOD_SHIPMENTS",
                "tableName": "WMTRANSACTIONDP",
                "label": "Location",
                "type": "select",
                "required": false,
                "acceptCustomValue": true,
                "visible": true
            }
        ]
    },
    {
        "groupId": 7,
        "label": "Pick Seq",
        "fields": [
            {
                "name": "LOTPICKSEQUENCE_SHIPMENTS",
                "tableName": "WMTRANSACTIONDP",
                "label": "Lot",
                "type": "select",
                "required": false,
                "visible": true,
                "acceptCustomValue": true,
            },
            {
                "name": "SUBLOTPICKSEQUENCE_SHIPMENTS",
                "tableName": "WMTRANSACTIONDP",
                "label": "Sublot",
                "type": "select",
                "required": true,
                "visible": true,
                "acceptCustomValue": true,
            },
            {
                "name": "UNITPICKSEQUENCE_SHIPMENTS",
                "tableName": "WMTRANSACTIONDP",
                "label": "Unit",
                "type": "select",
                "required": false,
                "acceptCustomValue": true,
                "visible": true
            },
            {
                "name": "LOCATIONPICKSEQUENCE_SHIPMENTS",
                "tableName": "WMTRANSACTIONDP",
                "label": "Location",
                "type": "select",
                "required": false,
                "acceptCustomValue": true,
                "visible": true,
            }
        ]
    },

    {
        "groupId": 8,
        "label": "Default When Creating New Lots",
        "fields": [
            {
                "name": "DEFAULTITEMLOTMANAGEMENTUNIT",
                "tableName": "WMTRANSACTIONDP",
                "label": "Mgmt Source",
                "type": "select",
                "required": false,
                "visible": true,
                
            },
            {
                "name": "POPULATELOTWITHCARRIER",
                "tableName": "WMTRANSACTIONDP",
                "label": "Carrier Info",
                "type": "select",
                "required": true,
                "visible": true
            },
            {
                "name": "LOTSTORAGEDATE",
                "tableName": "WMTRANSACTIONDP",
                "label": "Storage Date",
                "type": "select",
                "required": false,
                "visible": true
            },
            {
                "name": "LOTAVAILABLEDATE",
                "tableName": "WMTRANSACTIONDP",
                "label": "Available Date",
                "type": "select",
                "required": false,
                "visible": true
            }
        ]
    },
        {
        "groupId": 9,
        "label": "Allow Duplicate Codes",
        "fields": [
            {
                "name": "DUPLICATELOT",
                "tableName": "WMTRANSACTIONDP",
                "label": "Lot",
                "type": "select",
                "required": false,
                "visible": true,
                
            },
            {
                "name": "DUPLICATESUBLOT",
                "tableName": "WMTRANSACTIONDP",
                "label": "Sublot",
                "type": "select",
                "required": true,
                "visible": true
            }
        ]
    },
    {
        "groupId": 11,
        "label": "Default User Defined Fields",
        "fields": [
            {
                "name": "DETAILUDFIELDS",
                "tableName": "WMTRANSACTIONDP",
                "label": "UD Fields",
                "type": "select",
                "required": false,
                "visible": true,
                
            },
            {
                "name": "UPDATEUDFIELDS",
                "tableName": "WMTRANSACTIONDP",
                "label": "Update Info",
                "type": "select",
                "required": false,
                "visible": true,
                
            }
        ]
    },
    {
        "groupId": 12,
        "label": "Location - Reason Mandatory",
        "fields": [
            {
                "name": "REASONMANDATORY",
                "tableName": "WMTRANSACTIONDP",
                "label": "Reason Mandatory",
                "type": "select",
                "required": false,
                "visible": true,
                
            }
        ]
    },
    {
        "groupId":13,
        "label": "SSCC - Same to every detail line",
        "fields": [
            {
                "name": "USEONESSCCPERTRANS",
                "tableName": "WMTRANSACTIONDP",
                "label": "Use 1 SSCC",
                "type": "select",
                "required": false,
                "visible": true,
                
            }
        ]
    },
];

export {
    DetailsLayout,
}
